module.exports = __webpack_public_path__ + "img/dishini2.f1d7247c.png";